module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "choose-plan"
  }, [_c('li', {
    class: {
      active: _vm.changePlan == 'b2c'
    },
    on: {
      "click": function($event) {
        _vm.changePlan = 'b2c'
      }
    }
  }, [_vm._v("\n              Para Você\n            ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.changePlan == 'b2b'
    },
    on: {
      "click": function($event) {
        _vm.changePlan = 'b2b'
      }
    }
  }, [_vm._v("\n              Para Sua Empresa\n            ")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.changePlan == 'vpo'
    },
    on: {
      "click": function($event) {
        _vm.changePlan = 'vpo'
      }
    }
  }, [_vm._v("\n              Vale-pedágio\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.changePlan == 'vpo') ? _c('h3', {
    staticClass: "bold margin-b0 margin-t30"
  }, [_vm._v("TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.")]) : _c('h3', {
    staticClass: "bold margin-b0 margin-t30"
  }, [_vm._v("PLANOS")]), _vm._v(" "), (_vm.changePlan == 'b2c') ? _c('p', [_vm._v("Temos dois planos, com certeza um deles é ideal para você, é só escolher:")]) : (_vm.changePlan == 'vpo') ? _c('p', [_vm._v("Totalmente digital, "), _c('b', [_vm._v("SEM CUSTO")]), _vm._v(" e fácil de usar.")]) : _c('p', [_vm._v("Temos três planos, com certeza um deles é ideal para você, é só escolher:")]), _vm._v(" "), (_vm.changePlan == 'b2c') ? _c('b2c', {
    staticClass: "margin-t20",
    attrs: {
      "type": "adhesion"
    }
  }) : (_vm.changePlan == 'vpo') ? _c('vpo', {
    staticClass: "margin-t20",
    attrs: {
      "type": "adhesion"
    }
  }) : _c('b2b', {
    staticClass: "margin-t20",
    attrs: {
      "type": "adhesion"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-7e5332c9!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/services.vue
// module id = 2180
// module chunks = 1